import { useState } from 'react';
import PropTypes from 'prop-types';

function IconCardConfirm({
  className,
  width,
  height,
  id,
  color,
  hoverColor,
  viewBox,
  force,
}) {
  const [mainColor, setMainColor] = useState(color);
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox={viewBox}
      onMouseEnter={() => setMainColor(hoverColor)}
      onMouseLeave={() => setMainColor(color)}
    >
      <defs>
        <path
          id="icon-card-confirm"
          d="M18 5a3 3 0 013 3v9a3 3 0 01-3 3H6a3 3 0 01-3-3V8a3 3 0 013-3h12zm-6.801 10.05H4.6V17A1.4 1.4 0 006 18.4h5.199v-3.35zm8.2 0H12.8v3.35H18a1.4 1.4 0 001.4-1.4l-.001-1.95zM18 6.6H6A1.4 1.4 0 004.6 8v5.449h14.799L19.4 8A1.4 1.4 0 0018 6.6z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id={id} fill="#fff">
          <use xlinkHref="#icon-card-confirm" />
        </mask>
        <g fill={force ? color : mainColor} mask={`url(#${id})`}>
          <path d="M0 0h24v24H0z" />
        </g>
      </g>
    </svg>
  );
}

IconCardConfirm.defaultProps = {
  className: undefined,
  width: 24,
  height: 24,
  color: '#989898',
  hoverColor: '#989898',
  viewBox: '0,0,24,24',
  force: false,
};

IconCardConfirm.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  id: PropTypes.string.isRequired,
  color: PropTypes.string,
  hoverColor: PropTypes.string,
  viewBox: PropTypes.string,
  force: PropTypes.bool,
};

export default IconCardConfirm;
